import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/ui/Modal';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, Search, BookOpen } from 'lucide-react';

export default function Books() {
  const api = useApi();
  const { can } = useAuth();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null); // null | 'add' | book object
  const [form, setForm] = useState({ title: '', link: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const d = await api.get('/books');
    if (d) setBooks(d.books || []);
    setLoading(false);
  }

  function openAdd() { setForm({ title: '', link: '' }); setModal('add'); }
  function openEdit(b) { setForm({ title: b.title, link: b.link || '' }); setModal(b); }

  async function save() {
    if (!form.title.trim()) return toast.error('Title likhein');
    setSaving(true);
    try {
      if (modal === 'add') {
        const d = await api.post('/books', form);
        if (d?.book) { toast.success('Book add ho gayi!'); load(); setModal(null); }
        else toast.error(d?.error || 'Error');
      } else {
        const d = await api.put('/books/' + modal.id, form);
        if (d?.success) { toast.success('Update ho gayi!'); load(); setModal(null); }
        else toast.error(d?.error || 'Error');
      }
    } finally { setSaving(false); }
  }

  async function toggle(b) {
    await api.put('/books/' + b.id, { title: b.title, link: b.link, is_active: !b.is_active });
    load();
  }

  async function del(b) {
    if (!window.confirm(`"${b.title}" delete karein?`)) return;
    const d = await api.del('/books/' + b.id);
    if (d?.success) { toast.success('Delete ho gayi'); load(); }
  }

  const filtered = books.filter(b => b.title.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">📚 Kitabein</div>
        <div className="section-sub">Bot mein dikhne wali books manage karein</div>
      </div>

      <div className="page-actions">
        <div className="search-wrap" style={{ flex: 1, maxWidth: 300 }}>
          <Search size={13} className="search-icon" />
          <input className="input" placeholder="Search karein..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {can('books') && (
          <button className="btn btn-primary" onClick={openAdd}><Plus size={14} /> Nai Book</button>
        )}
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}><span className="spinner" /></div>
        ) : filtered.length === 0 ? (
          <div className="empty"><div className="empty-icon"><BookOpen size={36} /></div>Koi book nahi mili</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>#</th><th>Title</th><th>Link</th><th>Status</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((b, i) => (
                  <tr key={b.id}>
                    <td style={{ color: 'var(--text-muted)', width: 40 }}>{i + 1}</td>
                    <td style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{b.title}</td>
                    <td>
                      {b.link ? <a href={b.link} target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>🔗 Link</a> : <span style={{ color: 'var(--text-muted)' }}>—</span>}
                    </td>
                    <td>
                      {can('books') ? (
                        <label className="toggle" title={b.is_active ? 'Active' : 'Off'}>
                          <input type="checkbox" checked={!!b.is_active} onChange={() => toggle(b)} />
                          <span className="toggle-slider" />
                        </label>
                      ) : (
                        <span className={`badge ${b.is_active ? 'badge-green' : 'badge-grey'}`}>{b.is_active ? 'Active' : 'Off'}</span>
                      )}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {can('books') && <>
                          <button className="btn btn-icon btn-ghost btn-sm" onClick={() => openEdit(b)} title="Edit"><Pencil size={13} /></button>
                          <button className="btn btn-icon btn-danger btn-sm" onClick={() => del(b)} title="Delete"><Trash2 size={13} /></button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <Modal
          title={modal === 'add' ? '📚 Nai Book Add Karein' : '✏️ Book Edit Karein'}
          onClose={() => setModal(null)}
          footer={<>
            <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : null}
              {modal === 'add' ? ' Add Karein' : ' Save Karein'}
            </button>
          </>}
        >
          <div className="field">
            <label className="label">Book Title *</label>
            <input className="input" placeholder="Moeen ul Sarf..." value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} autoFocus />
          </div>
          <div className="field">
            <label className="label">PDF/Drive Link</label>
            <input className="input" placeholder="https://drive.google.com/..." value={form.link} onChange={e => setForm(p => ({ ...p, link: e.target.value }))} />
          </div>
        </Modal>
      )}
    </div>
  );
}